import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Button, Container, FormLabel, Grid, Input, Stack, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Getadmin, updateAdmin } from '../redux/actions/Adminaction';

export default function AdminPage() {
  const [inputFields, setInputFields] = useState({});

  const [fee, setFee] = useState('');

  const addInputField = () => {
    setInputFields((prevState) => ({
      ...prevState,
      [JSON.stringify(Object?.keys(inputFields)?.length)]: '',
    }));
  };

  const removeInputField = (index) => {
    const update = { ...inputFields };
    delete update?.[JSON.stringify(index)];
    setInputFields(update);
  };

  const reindexObjectKeys = (obj, key) => {
    const newObj = { ...obj };
    delete newObj[key];
    const reindexedObject = {};
    Object.values(newObj).map((item, index) => {
      reindexedObject[index] = item;
      return null;
    });
    setInputFields(reindexedObject);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(Getadmin());
  }, []);

  const Admindata = useSelector((state) => state?.Admin?.getAdmin?.data);
  useEffect(() => {
    setInputFields(Admindata?.TemporaryDeactivationMessage);
    console.log('Admindata?.', Admindata?.TemporaryDeactivationMessage);
    setFee(Admindata?.TransactionFee);
  }, [Admindata]);

  const handleChange = (event, index) => {
    setInputFields({ ...inputFields, [index]: event.target.value });
  };

  const handleSubmit = () => {
    dispatch(
      updateAdmin({
        TemporaryDeactivationMessage: inputFields,
      })
    );
  };
  return (
    <>
      <Helmet>
        <title> User | Minimal UI </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Admin
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              handleSubmit();
            }}
          >
            Update
          </Button>
        </Stack>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              border: '1px solid #bdc4ca',
              minWidth: '50%',
              minHeight: '400px',
              padding: '30px',
              borderRadius: '10px',
            }}
          >
            <Typography style={{ fontWeight: 'bold', marginTop: '10px' }}>Temporary Deactivation Message : </Typography>
            <Box style={{ marginLeft: '20px' }}>
              {inputFields &&
                Object.keys(inputFields)?.map((value, index) => {
                  return (
                    <Grid key={index} item>
                      <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                        <FormLabel>{index}: </FormLabel>
                        <Input
                          style={{ width: '100%', marginLeft: '10px' }}
                          type="text"
                          value={inputFields?.[value]}
                          name="MaxSalaryBand"
                          onChange={(e) => handleChange(e, index)}
                        />
                      </div>
                      {index >= Object.keys(Admindata?.TemporaryDeactivationMessage)?.length ? (
                        <Button
                          sx={{ marginTop: '10px' }}
                          onClick={() => reindexObjectKeys(inputFields, value)}
                          variant="contained"
                        >
                          Remove
                        </Button>
                      ) : (
                        ''
                      )}
                    </Grid>
                  );
                })}
            </Box>
            <div style={{ textAlign: 'center' }}>
              <Button sx={{ marginTop: '20px' }} onClick={addInputField} variant="contained">
                Add
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
